export const PREFIX = '/api/v1'

export default { PREFIX }
